export enum Alignments {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}
